import React, { useState } from "react";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./UserCreationForm.css";
import axios from "axios";

const API_BASE_URL = "http://localhost:8080/users";

const View = ({ loggedInUserRole, roleOptions }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [uid, setUid] = useState("");
    const [firstName, setFirstName] = useState("");
    const [middleName, setMiddleName] = useState("");
    const [lastName, setLastName] = useState("");
    const [emailId, setUstEmailId] = useState("");
    const [phoneNumber, setPhoneNumber] = useState("");
    const [role, setRole] = useState("");
    const [baseLocation, setBaseLocation] = useState("");
    const [doj, setDoj] = useState("");
    const [obd, setObd] = useState("");
    const [status, setStatus] = useState("Active");

    const [errors, setErrors] = useState({});
    const [dobMonth, setDobMonth] = useState("");
    const [dobDay, setDobDay] = useState("");
    
    const months = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];
    
    const days = Array.from({ length: 31 }, (_, i) => i + 1);
    
      // Function to get today's date in YYYY-MM-DD format for restricting DOJ input
      const getTodayDate = () => {
        const today = new Date();
        return today.toISOString().split("T")[0];
      };

      const validateFields = () => {
        let newErrors = {};

        if (!uid) newErrors.uid = "UID is required.";
        else if (!/^[a-zA-Z0-9]+$/.test(uid)) newErrors.uid = "UID must be alphanumeric.";
        else if (!/\d/.test(uid)) newErrors.uid = "UID must contain at least one number.";
        else if (uid.length < 6) newErrors.uid = "UID must be at least 6 characters long.";

        if (!firstName.trim()) {
            newErrors.firstName = "First Name is required.";
          } else if (!/^[A-Za-z]+$/.test(firstName.trim())) {
            newErrors.firstName = "First Name should contain only alphabets.";
          }
          
          if (middleName.trim() && !/^[A-Za-z]+$/.test(middleName.trim())) {
            newErrors.middleName = "Middle Name should contain only alphabets.";
          }
          
          if (!lastName.trim()) {
            newErrors.lastName = "Last Name is required.";
          } else if (!/^[A-Za-z]+$/.test(lastName.trim())) {
            newErrors.lastName = "Last Name should contain only alphabets.";
          }

        if (!emailId) {
            newErrors.emailId = "Email is required.";
          } else if (!/^[^\s@]+@ust\.com$/.test(emailId)) {
            newErrors.emailId = "Email must be in the format name@ust.com.";
          }
          
     if (phoneNumber.trim()) { 
        if (!/^\d+$/.test(phoneNumber)) {
            newErrors.phoneNumber = "Phone Number must contain only digits (0-9).";
        } else if (phoneNumber.trim() && phoneNumber.length < 10) {
            newErrors.phoneNumber = "Phone Number must be exactly 10 digits (Too Short).";
        } else if (phoneNumber.length > 10) {
            newErrors.phoneNumber = "Phone Number must be exactly 10 digits (Too Long).";
        }
      }

        if (!role) newErrors.role = "Role selection is required.";
        if (!baseLocation) newErrors.baseLocation = "Base Location is required.";
        if (!doj) newErrors.doj = "Date of Joining is required.";
    else if (doj > getTodayDate()) newErrors.doj = "Date of Joining cannot be in the future.";
    if (!obd) newErrors.obd = "Onboarding Date is required.";
        if (!status) newErrors.status = "Status selection is required.";

        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const isFormValid = () => {
        return (
            uid && 
            firstName.trim() &&
            lastName.trim() &&
            emailId &&
            role && baseLocation  && doj && obd && status 
        );
    }; 
    const handleUpdate = async () => {
      if (!validateFields()) return;
      setIsEditing(false);
      // Convert month string to integer (e.g., "January" -> 1, "February" -> 2, etc.)
      const dobMonthInt = months.indexOf(dobMonth) + 1;
  
      const userData = {
          uid,
          firstName,
          middleName,
          lastName,
          emailId,
          phoneNumber,
          role,
          baseLocation,
          dobMonth: dobMonthInt,  // Send separately
          dobDay, 
          doj,
          obd,
          status,
      };
  
      try {
          // Retrieve JWT token from local storage (assuming it's stored after login)
          const token = localStorage.getItem("token"); 
  
          const response = await axios.post(`${API_BASE_URL}`, userData, {
              headers: {
                  Authorization: `Bearer ${token}`, // Attach the token in the Authorization header
                  "Content-Type": "application/json"
              }
          });
  
          if (response.status === 200 || response.status === 201) {
              toast.success("User created successfully!", {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  theme: "light",
                  style: { fontSize: "14px", fontWeight: "normal", padding: "8px 20px", minWidth: "100px", marginTop: "60px" },
              });
          }
      } catch (error) {
          console.error("Error:", error);
  
          // Handle specific error cases
          if (error.response && error.response.status === 403) {
              toast.error("Unauthorized! Please log in again.", {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  theme: "light",
              });
          } else if (error.response && error.response.status === 400) {
              toast.error("Invalid input data!", {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  theme: "light",
              });
          } else {
              toast.error("User Already Exists!", {
                  position: "top-right",
                  autoClose: 3000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  theme: "light",
              });
          }
      }
  };
  

    return (
        <div className="max-w-7xl mx-auto p-8 bg-white  space-y-8">
            
          <h1 className="header">User Profile</h1>
    
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            <div className="flex flex-col space-y-2">
            <label className="text-xs font-medium"> 
  UID<span className="text-red-600">*</span>
</label>

<input type="text" value={uid} onChange={(e) => setUid(e.target.value)} placeholder="Enter UID" className="input-field rounded-lg border border-gray-300 px-2 py-1 text-sm placeholder:text-xs focus:outline-none focus:ring-2 focus:ring-blue-500" />
        {errors.uid && <span className="text-red-500 text-xs">{errors.uid}</span>}
            </div>
    
            <div className="flex flex-col space-y-2">
              <label className="text-xs font-medium ">First Name<span className="text-red-600">*</span></label>
              <input type="text" value={firstName} onChange={(e) => setFirstName(e.target.value)} placeholder="Enter First Name" className="input-field rounded-lg border border-gray-300 px-2 py-1 text-sm placeholder:text-xs focus:outline-none focus:ring-2 focus:ring-blue-500" />
              {errors.firstName && <span className="text-red-500 text-xs">{errors.firstName}</span>}
            </div>
    
            <div className="flex flex-col space-y-2">
              <label className="text-xs font-medium">Middle Name</label>
              <input type="text" value={middleName} onChange={(e) => setMiddleName(e.target.value)} placeholder="Enter Middle Name" className="input-field rounded-lg border border-gray-300 px-2 py-1 text-sm placeholder:text-xs focus:outline-none focus:ring-2 focus:ring-blue-500" />
              {errors.middleName && <span className="text-red-500 text-xs">{errors.middleName}</span>}
            </div>
    
            <div className="flex flex-col space-y-2">
              <label className="text-xs font-medium">Last Name<span className="text-red-600">*</span></label>
              <input type="text" value={lastName} onChange={(e) => setLastName(e.target.value)} placeholder="Enter Last Name" className="input-field rounded-lg border border-gray-300 px-2 py-1 text-sm placeholder:text-xs focus:outline-none focus:ring-2 focus:ring-blue-500" />
              {errors.lastName && <span className="text-red-500 text-xs">{errors.lastName}</span>}
            </div>
    
            <div className="flex flex-col space-y-2">
              <label className="text-xs font-medium">UST Email ID<span className="text-red-600">*</span></label>
              <input type="email" value={emailId} onChange={(e) => setUstEmailId(e.target.value)} placeholder="Enter UST Email ID" className="input-field rounded-lg border border-gray-300 px-2 py-1 text-sm placeholder:text-xs focus:outline-none focus:ring-2 focus:ring-blue-500" />
              {errors.emailId && <span className="text-red-500 text-xs">{errors.emailId}</span>}
            </div>
    
            <div className="flex flex-col space-y-2">
              <label className="text-xs font-medium">Phone Number</label>
              <input type="text" value={phoneNumber} onChange={(e) => setPhoneNumber(e.target.value)} placeholder="Enter Phone Number" className="input-field rounded-lg border border-gray-300 px-2 py-1 text-sm placeholder:text-xs focus:outline-none focus:ring-2 focus:ring-blue-500" />
              {errors.phoneNumber && <span className="text-red-500 text-xs">{errors.phoneNumber}</span>}
            </div>
    
            <div className="flex flex-col space-y-2">
              <label className="text-xs font-medium">Role<span className="text-red-600">*</span></label>
              <select value={role} onChange={(e) => setRole(e.target.value)} 
              className={`input-field rounded-lg border border-gray-300 px-2 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                role === "" ? "text-gray-500" : "text-black"
              }`}>
                <option value="" disabled>Select Role</option>
                {roleOptions[loggedInUserRole]?.map((roleOption, index) => (
                  <option key={index} value={roleOption} >{roleOption}</option>
                ))}
              </select>
              {errors.role && <span className="text-red-500 text-xs">{errors.role}</span>}
            </div>
    
            <div className="flex flex-col space-y-2">
              <label className="text-xs font-medium">Base Location<span className="text-red-600">*</span></label>
              <select value={baseLocation} onChange={(e) => setBaseLocation(e.target.value)} className={`input-field rounded-lg border border-gray-300 px-2 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                baseLocation === "" ? "text-gray-500" : "text-black"
              }`}>
                <option value="">Select Base Location</option>
                {["Trivandrum", "Kochi", "Bangalore", "Hyderabad", "Chennai", "Pune", "Noida", "Kolkata"].map((location) => (
                  <option key={location} value={location}>{location}</option>
                ))}
              </select>
              {errors.baseLocation && <span className="text-red-500 text-xs">{errors.baseLocation}</span>}
            </div>
    
            <div className="flex flex-col space-y-2 col-span-2 lg:col-span-1">
              <label className="text-xs font-medium">DOB</label>
              <div className="flex space-x-2">
                <select value={dobMonth} onChange={(e) => setDobMonth(e.target.value)} className={`input-field rounded-lg border border-gray-300 px-2 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                dobMonth === "" ? "text-gray-500" : "text-black"
              }`}>
                  <option value="">Month</option>
                  {months.map((month, index) => (
                    <option key={index} value={month}>{month}</option>
                  ))}
                </select>
                <select value={dobDay} onChange={(e) => setDobDay(e.target.value)} className={`input-field rounded-lg border border-gray-300 px-2 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                dobDay === "" ? "text-gray-500" : "text-black"
              }`}>
                  <option value="">Day</option>
                  {days.map((day) => (
                    <option key={day} value={day}>{day}</option>
                  ))}
                </select>
              </div>
              {errors.dob && <span className="text-red-500 text-xs">{errors.dob}</span>}
            </div>
    
            <div className="flex flex-col space-y-2">
              <label className="text-xs font-medium">DOJ<span className="text-red-600">*</span></label>
              <input type="date" value={doj} onChange={(e) => setDoj(e.target.value)} max={getTodayDate()} className={`input-field rounded-lg border border-gray-300 px-2 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                doj === "" ? "text-gray-500" : "text-black"
              }`} />
              {errors.doj && <span className="text-red-500 text-xs">{errors.doj}</span>}
            </div>
            <div className="flex flex-col space-y-2">
              <label className="text-xs font-medium">Onboarding Date<span className="text-red-600">*</span></label>
              <input type="date" value={obd} onChange={(e) => setObd(e.target.value)} min={doj || ""} disabled={!doj} className={`input-field rounded-lg border border-gray-300 px-2 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                obd === "" ? "text-gray-500" : "text-black"
              }`} />
              {errors.obd && <span className="text-red-500 text-xs">{errors.obd}</span>}
            </div>
    
            <div className="flex flex-col space-y-2">
              <label className="text-xs font-medium">Status<span className="text-red-600">*</span></label>
              <select value={status} onChange={(e) => setStatus(e.target.value)} className={`input-field rounded-lg border border-gray-300 px-2 py-2 text-xs focus:outline-none focus:ring-2 focus:ring-blue-500 ${
                status === "" ? "text-gray-500" : "text-black"
              }`}>
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>
              {errors.status && <span className="text-red-500 text-xs">{errors.status}</span>}
            </div>
          </div>
    
          <div className="flex justify-center mt-6">
            <button 
              className={`px-6 py-2 text-white rounded-lg shadow-md transition-transform duration-200 ${isFormValid() ? 'bg-[#1f425b] hover:bg-[#163245]' : 'bg-gray-400 cursor-not-allowed'}`}
              onClick={handleUpdate}
              disabled={!isFormValid()}
            >
              Save
            </button>
          </div>
    
          <ToastContainer />
        </div>
      );
    };
    
    export default View;
